var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcBaselineFacebook({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic:baseline-facebook"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M36.6663 19.9987C36.6663 10.7987 29.1997 3.33203 19.9997 3.33203C10.7997 3.33203 3.33301 10.7987 3.33301 19.9987C3.33301 28.0654 9.06634 34.782 16.6663 36.332V24.9987H13.333V19.9987H16.6663V15.832C16.6663 12.6154 19.283 9.9987 22.4997 9.9987H26.6663V14.9987H23.333C22.4163 14.9987 21.6663 15.7487 21.6663 16.6654V19.9987H26.6663V24.9987H21.6663V36.582C30.083 35.7487 36.6663 28.6487 36.6663 19.9987Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBaselineFacebook);
export default __webpack_public_path__ + "static/media/ic_baseline-facebook.378c4647c86c5288dc8a43bf9fdc6372.svg";
export { ForwardRef as ReactComponent };